import React from 'react';
import type AdvancedRoadmapsSetupType from '@atlassian/jira-spa-apps-advanced-roadmaps-setup/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Setup Page
 */

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAdvancedRoadmapsSetup = lazyForPaint<typeof AdvancedRoadmapsSetupType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-advanced-roadmaps-setup", jiraSpaEntry: "async-advanced-roadmaps-setup" */ '@atlassian/jira-spa-apps-advanced-roadmaps-setup'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyAdvancedRoadmapsSetup} pageId="advanced-roadmaps-setup" shouldShowSpinner />
);
